module.exports = __webpack_public_path__ + "files/white.070b191ebd39f544a83a2221785d958d.png";